<app-cart-nav></app-cart-nav>
@if (!cartProducts) {
  <app-loading [type]="-1" [size]="'50px'"></app-loading>
} @else {
  <div style="position: relative;">
    <div style="position: absolute; right: 10px; top: -5px; z-index: 999;">
      <mat-form-field style="width: 110px" class="form-element filterList">
        <mat-label>{{ 'ai.filter' | transloco }}</mat-label>
        <input inputrestriction="basic1" matInput autocomplete="off" #filterComponents placeholder="" (keyup)="applyFilter($event.target['value'])">
        <a matSuffix aria-label="Clear" (click)="filterComponents.value = '';applyFilter('');">
          <mat-icon>close</mat-icon>
        </a>
      </mat-form-field>
      <app-video-link style="display: inline-block;" videoLink="/help/product"></app-video-link>
    </div>
    <mat-tab-group animationDuration="0ms" tabGroupDrag mat-stretch-tabs="false" mat-align-tabs="start">
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">view_comfy</mat-icon>
          {{'general.products' | transloco}}
        </ng-template>
        @for (item of cartProducts | FilterForPipe:'description':filterComponents.value; track item; let ind = $index) {
          <app-product  [cartProduct]="item" [isFirstProduct]="ind === 0" fxLayout="column" id="{{ 'p_' + item.product_id }}">
          </app-product>
        }
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">list</mat-icon>
          {{'general.listView' | transloco}}
        </ng-template>
        <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
          <ng-container matColumnDef="item">
            <th mat-header-cell *matHeaderCellDef> {{'general.product' | transloco}}</th>
            <td mat-cell *matCellDef="let element">
              <!-- <app-logo [overrideDefaultClass]="imgStyle"></app-logo> -->
              <img class="fade-in product-img" loading="lazy" [ngClass]="{inverted: theme == '0'}" onerror="'assets/images/DSLogo.png'" src="{{this.productImages}}/thumbs/{{element.name}}.png"/>
            </td>
          </ng-container>
          <ng-container matColumnDef="name">
            <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'general.name' | transloco}}</th>
            <td mat-cell *matCellDef="let element"> {{element.name}} </td>
          </ng-container>
          <ng-container matColumnDef="description">
            <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'general.description' | transloco}}</th>
            <td mat-cell *matCellDef="let element"> {{element.description}} </td>
          </ng-container>
          <ng-container matColumnDef="price">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'general.price' | transloco}}</th>
            <td mat-cell *matCellDef="let element"> {{element.price | StringJSV2Pipe:stringJSPipeArgs}} </td>
          </ng-container>
          <ng-container matColumnDef="add">
            <th mat-header-cell *matHeaderCellDef>{{'general.addToCart' | transloco}}</th>
            <td mat-cell *matCellDef="let element">
              <button (click)="onAddCartNav(element)" mat-icon-button style="opacity: 0.8;">
                <mat-icon>add_shopping_cart</mat-icon>
              </button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" [showFirstLastButtons]="true"></mat-paginator>
      </mat-tab>
    </mat-tab-group>
  </div>
}
<ng-template let-modal #thumbDialogModal>
  <div mat-dialog-content>
    <div class="helper-image">
      <img class="mainImageDialog" alt="" src="{{productImages}}{{selectedThumb}}"/>
    </div>
  </div>
</ng-template>


